var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-md": "", fluid: "", "pa-2": "" } },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "panel",
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      !_vm.$LOCAL && (!_vm.hits || !_vm.hits.query)
                        ? [
                            _c("span", { staticClass: "hidden-sm-and-down" }, [
                              _vm._v("Results for job: "),
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "ticket" }, [
                              _vm._v(_vm._s(_vm.ticket)),
                            ]),
                          ]
                        : _vm.hits
                        ? [
                            _c("span", { staticClass: "hidden-sm-and-down" }, [
                              _vm._v("Results: "),
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "ticket" }, [
                              _vm._v(_vm._s(_vm.hits.query.header)),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  !_vm.$LOCAL && _vm.resultState == "PENDING"
                    ? _c(
                        "div",
                        { attrs: { slot: "desc" }, slot: "desc" },
                        [
                          _c(
                            "v-container",
                            {
                              attrs: { "fill-height": "", "grid-list-md": "" },
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c("v-flex", { attrs: { xs4: "" } }, [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: {
                                        src: require("./assets/marv-search_2x.png"),
                                        srcset:
                                          require("./assets/marv-search_2x.png") +
                                          " 2x, " +
                                          require("./assets/marv-search_3x.png") +
                                          " 3x",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs8: "" } }, [
                                    _c("h3", [_vm._v("Still Pending")]),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("Please wait a moment")]),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : !_vm.$LOCAL && _vm.resultState == "EMPTY"
                    ? _c(
                        "div",
                        { attrs: { slot: "desc" }, slot: "desc" },
                        [
                          _c(
                            "v-container",
                            {
                              attrs: { "fill-height": "", "grid-list-md": "" },
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c("v-flex", { attrs: { xs4: "" } }, [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: {
                                        src: require("./assets/marv-result_2x.png"),
                                        srcset:
                                          require("./assets/marv-result_2x.png") +
                                          " 2x, " +
                                          require("./assets/marv-result_3x.png") +
                                          " 3x",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs8: "" } }, [
                                    _c("h3", [_vm._v("No hits found!")]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      [
                                        _vm._v("Start a "),
                                        _c(
                                          "v-btn",
                                          { attrs: { to: "/search" } },
                                          [_vm._v("New Search")]
                                        ),
                                        _vm._v("?"),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : !_vm.$LOCAL && _vm.resultState != "RESULT"
                    ? _c(
                        "div",
                        { attrs: { slot: "desc" }, slot: "desc" },
                        [
                          _c(
                            "v-container",
                            {
                              attrs: { "fill-height": "", "grid-list-md": "" },
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c("v-flex", { attrs: { xs4: "" } }, [
                                    _c("img", {
                                      staticStyle: { "max-width": "100%" },
                                      attrs: {
                                        src: require("./assets/marv-error_2x.png"),
                                        srcset:
                                          require("./assets/marv-error_2x.png") +
                                          " 2x, " +
                                          require("./assets/marv-error_3x.png") +
                                          " 3x",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs8: "" } }, [
                                    _c("h3", [_vm._v("Error! ")]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      [
                                        _vm._v("Start a "),
                                        _c(
                                          "v-btn",
                                          { attrs: { to: "/search" } },
                                          [_vm._v("New Search")]
                                        ),
                                        _vm._v("?"),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resultState == "RESULT" && _vm.hits && _vm.hits.results
                    ? _c(
                        "template",
                        { slot: "content" },
                        [
                          _c(
                            "v-menu",
                            {
                              ref: "menuwrapper",
                              staticStyle: { "z-index": "99999 !important" },
                              attrs: { "offset-y": "", absolute: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var activation = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "div",
                                          { staticStyle: { display: "none" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                (_vm.menuActivator = activation)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3471006822
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-list",
                                _vm._l(_vm.menuItems, function (item, index) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: index,
                                      attrs: {
                                        "two-line": "",
                                        href: item.href,
                                        target: "_blank",
                                        rel: "noopener",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(item.label)),
                                          ]),
                                          _vm._v(" "),
                                          _c("v-list-item-subtitle", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.accession) +
                                                "\n                                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hits.results.length > 1
                            ? _c(
                                "v-tabs",
                                {
                                  staticStyle: { "margin-bottom": "2em" },
                                  attrs: {
                                    color:
                                      _vm.selectedDatabases > 0
                                        ? _vm.hits.results[
                                            _vm.selectedDatabases - 1
                                          ].color
                                        : null,
                                    "center-active": "",
                                    grow: "",
                                    "show-arrows": "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleChangeDatabase()
                                    },
                                  },
                                  model: {
                                    value: _vm.selectedDatabases,
                                    callback: function ($$v) {
                                      _vm.selectedDatabases = $$v
                                    },
                                    expression: "selectedDatabases",
                                  },
                                },
                                [
                                  _c("v-tab", [_vm._v("All databases")]),
                                  _vm._v(" "),
                                  _vm._l(_vm.hits.results, function (entry) {
                                    return _c("v-tab", { key: entry.db }, [
                                      _vm._v(
                                        _vm._s(
                                          entry.db.replaceAll(
                                            /_folddisco$/g,
                                            ""
                                          )
                                        ) +
                                          " (" +
                                          _vm._s(
                                            entry.alignments
                                              ? Object.values(entry.alignments)
                                                  .length
                                              : 0
                                          ) +
                                          ")"
                                      ),
                                    ])
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.hits.results, function (entry, index) {
                            return _vm.selectedDatabases == 0 ||
                              index + 1 == _vm.selectedDatabases
                              ? _c(
                                  "div",
                                  { key: entry.db },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "d-flex",
                                        style: {
                                          "flex-direction": _vm.$vuetify
                                            .breakpoint.xsOnly
                                            ? "column"
                                            : "row",
                                          "align-items": "center",
                                          flex: "0",
                                          "white-space": "nowrap",
                                        },
                                      },
                                      [
                                        _c(
                                          "h2",
                                          {
                                            staticClass: "mr-auto",
                                            staticStyle: {
                                              "margin-top": "0.5em",
                                              "margin-bottom": "1em",
                                              display: "inline-block",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "text-transform": "uppercase",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    entry.db.replaceAll(
                                                      /_folddisco$/g,
                                                      ""
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  entry.alignments
                                                    ? Object.values(
                                                        entry.alignments
                                                      ).length
                                                    : 0
                                                ) + " hits"
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        entry.hasTaxonomy
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: { large: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleSankeyVisibility(
                                                      entry.db
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.isSankeyVisible[
                                                        entry.db
                                                      ]
                                                        ? "Hide Taxonomy"
                                                        : "Show Taxonomy"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "d-flex flex-row",
                                        staticStyle: { gap: "24px" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "flex-basis": "100%",
                                            },
                                          },
                                          [
                                            _c("h3", [_vm._v("Filter")]),
                                            _vm._v(" "),
                                            _c("motif-filter", {
                                              attrs: {
                                                items: _vm.dbGaps[entry.db],
                                                value: _vm.gapFilter[entry.db]
                                                  ? _vm.gapFilter[entry.db]
                                                  : "",
                                                queryresidues:
                                                  entry.queryresidues,
                                                color: entry.color,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.$set(
                                                    _vm.gapFilter,
                                                    entry.db,
                                                    $event
                                                  )
                                                },
                                                "click:clear": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    _vm.gapFilter,
                                                    entry.db,
                                                    ""
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "flex-basis": "100%",
                                            },
                                          },
                                          [
                                            _c("h3", [_vm._v("Cluster")]),
                                            _vm._v(" "),
                                            _c("folddisco-hit-cluster", {
                                              attrs: { hits: entry },
                                              on: {
                                                cluster: function ($event) {
                                                  return _vm.$set(
                                                    _vm.clusters,
                                                    entry.db,
                                                    $event
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    entry.hasTaxonomy &&
                                    _vm.isSankeyVisible[entry.db]
                                      ? _c(
                                          "v-flex",
                                          [
                                            _c("SankeyDiagram", {
                                              attrs: {
                                                rawData:
                                                  entry.taxonomyreports[0],
                                                db: entry.db,
                                                currentSelectedNodeId:
                                                  _vm.localSelectedTaxId,
                                                currentSelectedDb:
                                                  _vm.selectedDb,
                                              },
                                              on: {
                                                selectTaxon:
                                                  _vm.handleSankeySelect,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "table",
                                      {
                                        staticClass: "v-table result-table",
                                        staticStyle: {
                                          position: "relativ",
                                          "margin-bottom": "3em",
                                        },
                                      },
                                      [
                                        _c("colgroup", [
                                          _c("col", {
                                            staticStyle: { width: "20%" },
                                          }),
                                          _vm._v(" "),
                                          entry.hasDescription
                                            ? _c("col", {
                                                staticStyle: { width: "30%" },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          entry.hasTaxonomy
                                            ? _c("col", {
                                                staticStyle: { width: "20%" },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("col", {
                                            staticStyle: { width: "10%" },
                                          }),
                                          _vm._v(" "),
                                          _c("col", {
                                            staticStyle: { width: "10%" },
                                          }),
                                          _vm._v(" "),
                                          _c("col", {
                                            staticStyle: { width: "6.5%" },
                                          }),
                                          _vm._v(" "),
                                          _c("col", {
                                            staticStyle: { width: "20%" },
                                          }),
                                          _vm._v(" "),
                                          _c("col", {
                                            staticStyle: { width: "6.5%" },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("thead", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              {
                                                class:
                                                  "wide-" +
                                                  (3 -
                                                    entry.hasDescription -
                                                    entry.hasTaxonomy),
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                Target\n                            "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            entry.hasDescription
                                              ? _c(
                                                  "th",
                                                  [
                                                    _vm._v(
                                                      "\n                                Description\n                                "
                                                    ),
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: {
                                                          "open-delay": "300",
                                                          top: "",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function (
                                                                ref
                                                              ) {
                                                                var on = ref.on
                                                                return [
                                                                  _c(
                                                                    "v-icon",
                                                                    _vm._g(
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "16px",
                                                                            float:
                                                                              "right",
                                                                          },
                                                                      },
                                                                      on
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .$MDI
                                                                            .HelpCircleOutline
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            "Triple click to select whole cell (for very long identifiers)"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            entry.hasTaxonomy
                                              ? _c("th", [
                                                  _vm._v("Scientific Name"),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("th", { staticClass: "thin" }, [
                                              _vm._v("idf-score"),
                                            ]),
                                            _vm._v(" "),
                                            _c("th", { staticClass: "thin" }, [
                                              _vm._v("RMSD"),
                                            ]),
                                            _vm._v(" "),
                                            _c("th", { staticClass: "thin" }, [
                                              _vm._v("Nodes"),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              [
                                                _vm._v(
                                                  "\n                                Matched residues\n                                "
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      "open-delay": "300",
                                                      top: "",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function (ref) {
                                                            var on = ref.on
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                _vm._g(
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "16px",
                                                                        float:
                                                                          "right",
                                                                      },
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$MDI
                                                                        .HelpCircleOutline
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        "The position of the aligned motif residues in the target"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "alignment-action thin",
                                              },
                                              [_vm._v("Structure")]
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.clusters[entry.db],
                                          function (clu, key) {
                                            return _c(
                                              "tbody",
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      void (_vm.clusterShown = false)
                                                    ) +
                                                    "\n                        "
                                                ),
                                                _vm._l(
                                                  clu.map(function (x) {
                                                    return entry.alignments[x]
                                                  }),
                                                  function (group, groupidx) {
                                                    return [
                                                      _vm._l(
                                                        group,
                                                        function (item, index) {
                                                          return _vm.isGroupVisible(
                                                            group
                                                          ) &&
                                                            _vm.isItemVisible(
                                                              entry.db,
                                                              item
                                                            )
                                                            ? [
                                                                Object.keys(clu)
                                                                  .length !=
                                                                  Object.keys(
                                                                    entry.alignments
                                                                  ).length &&
                                                                _vm.clusterShown ==
                                                                  false
                                                                  ? _c("tr", [
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              colspan:
                                                                                "6",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "strong",
                                                                            [
                                                                              _vm._v(
                                                                                "Cluster: " +
                                                                                  _vm._s(
                                                                                    key ==
                                                                                      -1
                                                                                      ? "Noise"
                                                                                      : key
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      void (_vm.clusterShown = true)
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                                _c(
                                                                  "tr",
                                                                  {
                                                                    class: [
                                                                      "hit",
                                                                      {
                                                                        active:
                                                                          item.active,
                                                                      },
                                                                    ],
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "db long",
                                                                        style: {
                                                                          "border-color":
                                                                            entry.color,
                                                                        },
                                                                        attrs: {
                                                                          "data-label":
                                                                            "Target",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "anchor",
                                                                            staticStyle:
                                                                              {
                                                                                position:
                                                                                  "absolute",
                                                                                top: "0",
                                                                              },
                                                                            attrs:
                                                                              {
                                                                                id: item.id,
                                                                              },
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        Array.isArray(
                                                                          item.href
                                                                        )
                                                                          ? _c(
                                                                              "a",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    "text-decoration":
                                                                                      "underline",
                                                                                    color:
                                                                                      "#2196f3",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    rel: "noopener",
                                                                                    title:
                                                                                      item.target,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.forwardDropdown(
                                                                                        $event,
                                                                                        item.href
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.targetname
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "a",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    href: item.href,
                                                                                    target:
                                                                                      "_blank",
                                                                                    rel: "noopener",
                                                                                    title:
                                                                                      item.target,
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.targetname
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    entry.hasDescription
                                                                      ? _c(
                                                                          "td",
                                                                          {
                                                                            staticClass:
                                                                              "long",
                                                                            attrs:
                                                                              {
                                                                                "data-label":
                                                                                  "Description",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    title:
                                                                                      item.description,
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.description
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    entry.hasTaxonomy
                                                                      ? _c(
                                                                          "td",
                                                                          {
                                                                            staticClass:
                                                                              "long",
                                                                            attrs:
                                                                              {
                                                                                "data-label":
                                                                                  "Taxonomy",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "a",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    href:
                                                                                      "https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?mode=Info&id=" +
                                                                                      item.taxId,
                                                                                    target:
                                                                                      "_blank",
                                                                                    rel: "noopener",
                                                                                    title:
                                                                                      item.taxName,
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    item.taxName
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "thin",
                                                                        attrs: {
                                                                          "data-label":
                                                                            "idf-score",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.idfscore
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "thin",
                                                                        attrs: {
                                                                          "data-label":
                                                                            "RMSD",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.rmsd
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "thin",
                                                                        attrs: {
                                                                          "data-label":
                                                                            "Node count",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.nodecount
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        attrs: {
                                                                          "data-label":
                                                                            "Matched residues",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "matched-residues-text",
                                                                            attrs:
                                                                              {
                                                                                title:
                                                                                  item.targetresidues,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.targetresidues
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "td",
                                                                      {
                                                                        staticClass:
                                                                          "alignment-action thin",
                                                                        attrs: {
                                                                          rowspan: 1,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "v-btn v-btn--icon v-btn--round v-btn--text v-size--default",
                                                                            class:
                                                                              {
                                                                                "v-btn--outlined":
                                                                                  _vm.alignment &&
                                                                                  item.target ==
                                                                                    _vm
                                                                                      .alignment
                                                                                      .target,
                                                                                "theme--dark":
                                                                                  _vm
                                                                                    .$vuetify
                                                                                    .theme
                                                                                    .dark,
                                                                              },
                                                                            attrs:
                                                                              {
                                                                                type: "button",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.showAlignment(
                                                                                    item,
                                                                                    entry.db,
                                                                                    $event
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "v-btn__content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "v-icon notranslate theme--dark",
                                                                                    attrs:
                                                                                      {
                                                                                        "aria-hidden":
                                                                                          "true",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "svg",
                                                                                      {
                                                                                        staticClass:
                                                                                          "v-icon__svg",
                                                                                        attrs:
                                                                                          {
                                                                                            xmlns:
                                                                                              "http://www.w3.org/2000/svg",
                                                                                            viewBox:
                                                                                              "0 0 24 24",
                                                                                            role: "img",
                                                                                            "aria-hidden":
                                                                                              "true",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "path",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                d: "M5,13H19V11H5M3,17H17V15H3M7,7V9H21V7",
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            : _vm._e()
                                                        }
                                                      ),
                                                    ]
                                                  }
                                                ),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e()
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        [
          _vm.alignment != null && _vm.targetPdb != null
            ? _c(
                "panel",
                {
                  staticClass: "alignment",
                  style: "top: " + _vm.alnBoxOffset + "px;",
                },
                [
                  _c("StructureViewerMotif", {
                    key: "ap-" + _vm.alignment.dbkey,
                    attrs: {
                      slot: "content",
                      alignment: _vm.alignment,
                      queryPdb: _vm.queryPdb,
                      targetPdb: _vm.targetPdb,
                      lineLen: _vm.fluidLineLen,
                    },
                    slot: "content",
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }